module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e996334"
    }
  }, [_c('b', [_vm._v("TAPENADE")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e996834"
    }
  }, [_c('b', [_c('i', [_vm._v("This Provençal olive spread can be enjoyed on crisp bread or crackers or as a condiment for fish or chicken.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e997834"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e998334"
    }
  }, [_vm._v("2 garlic cloves, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e998634"
    }
  }, [_vm._v("1½ cups Gaeta or Kalamata olives, pitted")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e999734"
    }
  }, [_vm._v("½ cup pimiento-stuffed olives")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1000734"
    }
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1001034"
    }
  }, [_vm._v("1 teaspoon fennel seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1001334"
    }
  }, [_vm._v("1 teaspoon freshly grated orange peel")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1001834"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 1-quart saucepan, heat "), _c('i', [_vm._v("2 cups water ")]), _vm._v("to boiling over high heat. Add garlic and cook 3 minutes to blanch; drain.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1003634"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In food processor with knife blade attached, combine olives, oil, fennel seeds, orange peel, and garlic; process until chopped. Transfer to bowl; cover and refrigerate up 3 days. Makes about 1¼ cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1006434"
    }
  }, [_vm._v("Each tablespoon: About 41 calories, 0g protein, 2g carbohydrate, 4g total fat (0g saturated), 0mg cholesterol, 264mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136df51b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c17_r1.vue
// module id = 117
// module chunks = 0